import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { Button } from '@design-system/components/button/button';
import { SwapProposal, SwapSet } from '../model/swaps.domain';
import { useDraftSets } from '../model/useDraftSets';
import { DraftSetRow } from './DraftSetRow';
import { SwapThumb } from './SwapThumb';
import * as styles from './CreatorApprovedSwaps.css';

export const ExerciseSettingsModal = ({
  proposal,
  onSave,
  onClose,
}: {
  proposal: SwapProposal;
  onSave: (sets: SwapSet[]) => void;
  onClose: () => void;
}) => {
  const draft = useDraftSets(proposal.sets);
  const showDuration = draft.sets.length === 1;

  return (
    <Modal
      isOpen
      onClose={onClose}
      title="Exercise settings"
      largeTitle
      primaryCta={{
        caption: 'Save',
        onClick: () => onSave(draft.toSwapSets()),
        state: draft.valid ? undefined : 'disabled',
      }}
      secondaryCta={{ caption: 'Cancel', onClick: onClose }}
      testId="exercise-settings-modal"
    >
      <div className={styles.modalExerciseRow}>
        <SwapThumb media={proposal.media} />
        <Typography>{proposal.name}</Typography>
      </div>
      <div className={styles.modalSets}>
        {draft.sets.map((set, i) => (
          <DraftSetRow
            key={set.key}
            label={showDuration ? 'Duration' : `Set ${i + 1}`}
            reps={set.reps}
            onChange={(reps) => draft.updateSet(set.key, reps)}
            onRemove={i !== 0 ? () => draft.removeSet(set.key) : undefined}
          />
        ))}
        <Button
          color="primaryTonal"
          leftIcon={faPlus}
          className={styles.modalAddSetButton}
          onClick={draft.addSet}
        >
          Set
        </Button>
      </div>
    </Modal>
  );
};
